import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import moment from 'moment';
import { Subscription } from "rxjs";
import { ImpersonationService } from "../../../../auth/apigee/impersonation.service";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { VisitsCallsTargetsService, VisitsCallsTargetsServiceData } from "../../services/visitsCallsTargetsKpi/visitsCallsTargets.service";
import { ColumnDefinition, DateColumnDefinition, TextColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { SingleSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";

export class VisitsTargetData {
    public visits: number;
    public target: number;
    public progress: number;

    constructor(visits: number, target: number) {
        this.visits = visits;
        this.target = target;
        this.progress = target != 0 ? Math.min(100, visits / target * 100) : 100;
    }
}

export class VisitsTargetDetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;
    }
}

@Component({
    selector: 'visits-target-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class VisitsTargetKpiServiceHostComponent extends SingleSummaryDetailKpiServiceHost<VisitsCallsTargetsService, VisitsCallsTargetsServiceData, VisitsTargetData, VisitsTargetDetailData>
    implements OnDestroy {
    public getClassName() { return "VisitsTargetKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;
    @Input() public messageDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: VisitsCallsTargetsService) {
        super(zone, logger, summaryService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: VisitsCallsTargetsServiceData, updateRequested: Boolean): VisitsTargetData {

        if (data.consultantEntry) {
            let thisWeek = moment().isoWeek();
            let updateTime = this.extractUpdateTime(data);
            let now = moment();
            if (updateTime && moment(updateTime).isoWeek() == thisWeek) {
                let diff = moment.duration(now.diff(moment(data.consultantEntry.visitsUpdateTimestamp)));
                if (diff.hours() < 2 && this.summaryData && updateRequested) {
                    this.messageDialog.open();
                }

                let visitCount = (data.consultantEntry.visits || []).filter(x => moment(x.updateTimestamp).isoWeek() == thisWeek).length;
                return new VisitsTargetData(visitCount, data.consultantEntry.visitsTarget);
            } else {
                return this.getDefaultSummaryData();
            }
        } else {
            return this.getDefaultSummaryData();
        }
    }

    protected getDefaultSummaryData(): VisitsTargetData {
        let data = new VisitsTargetData(0, 0);
        return data;
    }

    protected extractUpdateTime(data: VisitsCallsTargetsServiceData): Date {
        if (data.consultantEntry) {
            if (data.consultantEntry.visitsUpdateTimestamp) {
                if (data.consultantEntry.visitsTargetUpdateTimestamp) {
                    if (moment(data.consultantEntry.visitsUpdateTimestamp).isBefore(moment(data.consultantEntry.visitsTargetUpdateTimestamp))) {
                        return data.consultantEntry.visitsTargetUpdateTimestamp;
                    } else {
                        return data.consultantEntry.visitsUpdateTimestamp;
                    }
                } else {
                    data.consultantEntry.visitsUpdateTimestamp;
                }
            }
            else {
                if (data.consultantEntry.visitsTargetUpdateTimestamp) {
                    return data.consultantEntry.visitsTargetUpdateTimestamp;
                } else {
                    return new Date();
                }
            }
        }

        return new Date();
    }

    protected processDetailData(data: VisitsCallsTargetsServiceData): VisitsTargetDetailData {
        if (data.consultantEntry) {

            let thisWeek = moment().isoWeek();

            let columnDefinitions = [
                new TextColumnDefinition("Cliente"),
                new TextColumnDefinition("Segmento"),
                new TextColumnDefinition("Tipo"),
                new DateColumnDefinition("Fecha", (data) => moment(data).format("DD/MM/YYYY"))
            ];

            let tabledata = [];
            for (let visit of (data.consultantEntry.visits || []).filter(x => moment(x.updateTimestamp).isoWeek() == thisWeek)) {
                data.consultantEntry.visits.sort(function (a, b) {
                    if (a.date > b.date) {
                        return 1;
                    }
                    if (a.date < b.date) {
                        return -1;
                    }
                    // a must be equal to b
                    return 0;
                });

                tabledata.push([

                    visit.clientName,
                    "S" + visit.segment,
                    visit.type,
                    moment(visit.date).startOf("day")
                ]);
            }

            return new VisitsTargetDetailData(columnDefinitions, tabledata);
        } else return this.getDefaultDetailData();
    }

    protected getDefaultDetailData() {
        let columnDefinitions = [
            new TextColumnDefinition("Cliente"),
            new TextColumnDefinition("Segmento"),
            new TextColumnDefinition("Tipo"),
            new DateColumnDefinition("Fecha", (data) => moment(data).format("DD/MM/YYYY"))
        ];

        return new VisitsTargetDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }
}
